import styled from "styled-components";
import { Button } from "../../atoms";

export const InstallPWABtn = styled(Button)`
  margin-top: 30px;
  border-radius: 4px;
`;

export const Content = styled.div`
  display: flex;
  flex-flow: row wrap;
  text-align: justify;
  padding: 35px 15px;
  height: 100%;
  background-color: ${(theme) => theme.theme.popupBackground};
  color: ${(theme) => theme.theme.etDark8};
  &.active {
    align-content: space-around;
  }
  font-size: 14px;
  border-radius: 0;
  span:first-child {
    margin-bottom: 10px;
  }
`;
